
export default {
  props: {
    field: {
      type: [String, Object],
      required: true,
    },
  },
  methods: {
    richTextToHtml(field) {
      return this.$storyapi.richTextResolver.render(field)
    },
  },
}
